realmCommerceApp.controller("CartController", CartController);
"use strict";

/*@ngInject*/
function CartController($uibModal, $window, cartService, customerService, apiService, gtmEcommerceService, messagesService) {
    var vm = this;
    vm.addItem = addItem;
    vm.addBooklistItems = addBooklistItems;
    vm.getItem = getItem;
    vm.getCartPreviewItems = getCartPreviewItems;
    vm.getItems = getItems;
    vm.unavailableItems = [];
    vm.updateItem = updateItem;
    vm.setItemQuantity = setItemQuantity;
    vm.getCart = getCart;
    vm.getCartPreview = getCartPreview;

    vm.cartModel = {};
    vm.getCustomer = getCustomer;
    vm.promptRemoveCartItem = promptRemoveCartItem;
    vm.promptRemoveCartItems = promptRemoveCartItems;
    vm.continueShopping = continueShopping;
    vm.applyVoucherCode = applyVoucherCode;
    vm.removeVouchers = removeVouchers;

    activate();

    function activate() {
        updateCart(vm.getCart());
    }

    function getCustomer() {
        return customerService.getCustomer();
    }

    function getCart() {
        return cartService.getCart();
    }

    function getCartPreview() {
        return cartService.getCartPreview();
    }

    function getItem(cartItemId) {
        return cartService.byProperty("cartItemId", cartItemId)[0];
    }

    function getItems() {
        if (typeof cartService.getCart().items != 'undefined') {
            return cartService.getCart().items;
        }
    }

    function getCartPreviewItems() {
        if (typeof cartService.getCartPreview().items != 'undefined') {
            return cartService.getCartPreview().items;
        }
    }

    function addItem(productId, quantity) {
        cartService.addItem(productId, quantity);
    }

    function addBooklistItems(booklistId) {
        cartService.addBooklistItems(booklistId).then((data) => {
            data.bookListProducts.forEach((product) => {
                gtmEcommerceService.sendAddToCart(product, 'productDetails', 1);
            });
        });
    }

    function updateItem(cartItemId) {
        cartService.updateItem(cartItemId);
    }

    function setItemQuantity(item, quantity) {
        if (quantity > 0 && quantity <= 5) {
            item.quantity = quantity;
            updateItem(item);
        }
    }

    function promptRemoveCartItem(item) {
        let modalInstance = $uibModal.open({
            template: require('../layout/modal/removeItem.cart.html'),
            controller: 'CartItemsController',
            controllerAs: 'vm',
            resolve: {
                cartItemModel: () => item
            }
        });

        return modalInstance.result.then((result) => {
            cartService.removeItem(item.entity_id).then(function () {
                messagesService.success({ text : "The item was removed from your cart" });
                updateCart(vm.getCart());
            });
        });
    }

    function promptRemoveCartItems() {
        let modalInstance = $uibModal.open({
            template: require('../layout/modal/removeItems.cart.html'),
            controller: 'CartItemsController',
            controllerAs: 'vm',
            resolve: {
                cartItemModel: {}
            }
        });

        return modalInstance.result.then((items) => {
            items.forEach((item) => {
                gtmEcommerceService.sendRemoveFromCart(item.product, 'productDetails', 1);
            });
        });
    }

    function continueShopping() {
        // Using angular `$location.url('/search/?type=product')` results in `/cart/#!/search/?type=product`
        return window.location.href = '/search?type=product';
    }

    function updateCart(cart){
        vm.cart = cart;
        if(vm.cart.vouchers && vm.cart.vouchers.length){
            vm.addedVoucher = vm.cart.vouchers[0];
        }
    }
    function applyVoucherCode() {
        apiService.applyVoucher(vm.voucherCode)
            .then((data) => {
                    updateCart(data.cart);
                    messagesService.success({text:data.message});
            })
            .catch(err => messagesService.warning({text:err.data.message}))
            .finally(() => $window.scrollTo(0, 0));
    }

    function removeVouchers() {
        apiService.removeVouchers()
            .then((data) => {
                vm.cart = data.cart;
                messagesService.success({text: 'Vouchers Removed'});
                $window.scrollTo(0, 0);
            });
    }
}



// WEBPACK FOOTER //
// ./static/js/app/cart/cart.controller.js